import { render } from "./HimawariTalent.vue?vue&type=template&id=24e5032e&scoped=true&ts=true&lang=pug"
import script from "./HimawariTalent.vue?vue&type=script&lang=ts"
export * from "./HimawariTalent.vue?vue&type=script&lang=ts"

import "./HimawariTalent.vue?vue&type=style&index=0&id=24e5032e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e5032e"]])

export default __exports__